import useBreakPoinst from "@hooks/useBreakPoinst";
import dayjs from "dayjs";

import PropertyIcon from "@assets/svg/PropertyIcon.svg?react";
import BathtubIcon from "@assets/svg/Bath.svg?react";
import BedroomIcon from "@assets/svg/Bed.svg?react";
import UserIcon from "@assets/svg/UserIcon.svg?react";
import {
  PaymentSuccessContainer,
  PaymentSuccessTitle,
  PaymentSuccessDescription,
  PaymentSuccessInfoBox,
  PaymentSuccessButton,
  PaymentSuccessBadge,
  PaymentSuccessBadgeText,
  PaymentSuccessIcon,
  PaymentSuccessArrowIcon,
  PaymentSuccessMsoolIcon,
  PaymentSuccessFeaturesContainer,
  PaymentSuccessFeatureItem,
  PaymentSuccessPaymentContainer,
  PaymentSuccessPaymentTitle,
  PaymentSuccessPaymentRow,
  PaymentSuccessPaymentLabel,
  PaymentSuccessPaymentValue,
  PaymentSuccessPaymentTotal,
  PaymentSuccessDetailsSection,
  PaymentSuccessPropertyInfoContainer,
  PaymentSuccessPropertyTextContainer,
  PaymentSuccessPropertyTitle,
  PaymentSuccessPropertyLocation,
  PaymentSuccessBookingDetailsContainer,
  PaymentSuccessBookingDetailsTitle,
  PaymentSuccessBookingDetailsText,
  PaymentSuccessBookingGuestsText,
  PaymentSuccessDivider,
  PaymentSuccessPaymentDivider,
} from "./styles";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useWelcomeBook } from "@services";
import { useState, useEffect } from "react";
import GuestPortalPaymentFail from "./GuestPortalPaymentFail";
import { Loading } from "@components";

const PaymentStatus = () => {
  const [paymentStatus, setPaymentStatus] = useState(false);
  const { id } = useParams();
  const location = useLocation();
  const { GetWelcomeBookQuery } = useWelcomeBook();
  const { data, isLoading } = GetWelcomeBookQuery(id ?? "");
  const result = data?.data?.result;
  const { isPhone } = useBreakPoinst();
  const navigate = useNavigate();
  // Check URL for status=paid and set payment status
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const status = urlParams.get("status");
    if (status === "paid") {
      setPaymentStatus(true);
    }
  }, [location.search]);

  const title = "تم الدفع بنجاح، وتم تأكيد حجزك!";
  const description = "تم تأكيد الحجز بنجاح! نتطلع إلى استضافتك قريبًا.";
  const infoBox =
    "تم إرسال رسالة تأكيد إلى بريدك الإلكتروني المسجل تحتوي على جميع تفاصيل الحجز.";
  const buttonText = "عرض تفاصيل الحجز";

  // Format dates using dayjs
  const formatDate = (dateString: string) => {
    return dayjs(dateString).format("D MMMM YYYY");
  };

  const checkInDate = result?.checkInDate ? formatDate(result.checkInDate) : "";
  const checkOutDate = result?.checkOutDate
    ? formatDate(result.checkOutDate)
    : "";

  // Calculate number of nights
  const calculateNights = () => {
    if (result?.checkInDate && result?.checkOutDate) {
      const checkIn = dayjs(result.checkInDate);
      const checkOut = dayjs(result.checkOutDate);
      return checkOut.diff(checkIn, "day");
    }
    return 0;
  };

  const numberOfNights = calculateNights();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loading />
      </div>
    );
  }
  return (
    <>
      {paymentStatus ? (
        <PaymentSuccessContainer $isPhone={isPhone}>
          {/* svg iCon */}
          <PaymentSuccessIcon $isPhone={isPhone} />
          <PaymentSuccessTitle $isPhone={isPhone}>{title}</PaymentSuccessTitle>

          <PaymentSuccessDescription $isPhone={isPhone}>
            {description}
          </PaymentSuccessDescription>
          {/* Details section  */}
          <PaymentSuccessDetailsSection>
            <PaymentSuccessPropertyInfoContainer>
              <PropertyIcon width={100} height={100} />
              <PaymentSuccessPropertyTextContainer>
                <PaymentSuccessPropertyTitle>
                  {result?.propertyName}
                </PaymentSuccessPropertyTitle>
                <PaymentSuccessPropertyLocation>
                  {result?.propertyName}
                </PaymentSuccessPropertyLocation>
                <PaymentSuccessFeaturesContainer $isPhone={isPhone}>
                  <PaymentSuccessFeatureItem $isPhone={isPhone}>
                    <BathtubIcon />
                    {result?.bathroomCount} حمامات
                  </PaymentSuccessFeatureItem>
                  <PaymentSuccessFeatureItem $isPhone={isPhone}>
                    <BedroomIcon />
                    {result?.bedCount} أسرّة
                  </PaymentSuccessFeatureItem>
                  <PaymentSuccessFeatureItem $isPhone={isPhone}>
                    <UserIcon />
                    {result?.guestCount} ضيوف
                  </PaymentSuccessFeatureItem>
                </PaymentSuccessFeaturesContainer>
              </PaymentSuccessPropertyTextContainer>
            </PaymentSuccessPropertyInfoContainer>
            <PaymentSuccessDivider />
            <PaymentSuccessBookingDetailsContainer>
              <PaymentSuccessBookingDetailsTitle>
                تفاصيل الحجز
              </PaymentSuccessBookingDetailsTitle>
              <PaymentSuccessBookingDetailsText>
                {checkInDate && checkOutDate
                  ? `${checkInDate} - ${checkOutDate}`
                  : "تاريخ الحجز غير متوفر"}
              </PaymentSuccessBookingDetailsText>
              <PaymentSuccessBookingGuestsText>
                <UserIcon />
                {result?.guestCount} ضيوف
              </PaymentSuccessBookingGuestsText>
            </PaymentSuccessBookingDetailsContainer>
            <PaymentSuccessDivider />

            <PaymentSuccessPaymentContainer $isPhone={isPhone}>
              <PaymentSuccessPaymentTitle $isPhone={isPhone}>
                بيانات الدفع
              </PaymentSuccessPaymentTitle>
              <PaymentSuccessPaymentRow>
                <PaymentSuccessPaymentLabel $isPhone={isPhone}>
                  {result?.numberOfNights} ليالي
                </PaymentSuccessPaymentLabel>
                <PaymentSuccessPaymentValue $isPhone={isPhone}>
                  {result?.totalPrice} ريال
                </PaymentSuccessPaymentValue>
              </PaymentSuccessPaymentRow>
              <PaymentSuccessPaymentDivider />
              <PaymentSuccessPaymentRow>
                <PaymentSuccessPaymentTotal $isPhone={isPhone}>
                  السعر الإجمالي للحجز
                </PaymentSuccessPaymentTotal>
                <PaymentSuccessPaymentTotal $isPhone={isPhone}>
                  {result?.totalPrice} ريال
                </PaymentSuccessPaymentTotal>
              </PaymentSuccessPaymentRow>
            </PaymentSuccessPaymentContainer>
          </PaymentSuccessDetailsSection>

          <PaymentSuccessInfoBox $isPhone={isPhone}>
            {infoBox}
          </PaymentSuccessInfoBox>
          <PaymentSuccessButton
            onClick={() => {
              navigate(`/guest/${id}`);
            }}
            $isPhone={isPhone}
          >
            {buttonText}
            <PaymentSuccessArrowIcon $isPhone={isPhone} />
          </PaymentSuccessButton>
          <PaymentSuccessBadge $isPhone={isPhone}>
            <PaymentSuccessBadgeText $isPhone={isPhone}>
              مشغل بواسطة مسؤول
            </PaymentSuccessBadgeText>
            <PaymentSuccessMsoolIcon $isPhone={isPhone} />
          </PaymentSuccessBadge>
        </PaymentSuccessContainer>
      ) : (
        <GuestPortalPaymentFail />
      )}
    </>
  );
};

export default PaymentStatus;
